import React, { 
  useEffect, 
  useMemo, 
  useState 
} from "react";
import {
  Row, 
  Col, 
  Card, 
  CardBody, 
  CardTitle, 
  CardHeader,
} from "reactstrap";
import {
  Table, Thead, Tbody, Tr, Th, Td
} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import CustomPagination from "components/Common/CustomPagination";
import TableLoader from "components/Common/Loader";
import WinnerButton from "./WinnerButton";
import CompetitionRewardModal from "../Competition/CompetitionRewardModal";

function CompetitionStats(props) {
  const [rewardModalValues, setRewardModalValues] = useState({});
  const [competitionStats, setCompetitionStats] = useState([]);
  const [show, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);

  useEffect(() => {
    setCompetitionStats(props.competitionStats || []);
    setPage(1);
  }, [props.competitionStats]);

  useEffect(() => {
    // keep current page within bounds when dataset shrinks
    const totalPages = Math.max(1, Math.ceil((competitionStats?.length || 0) / sizePerPage));
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [competitionStats, sizePerPage, page]);

  const handlePageChange = (newPage, newSize = sizePerPage) => {
    const limit = Number(newSize) || 10;
    setSizePerPage(limit);
    setPage(newPage || 1);
  };

  const handleSizeChange = (value) => {
    const limit = Number(value) || 10;
    setSizePerPage(limit);
    setPage(1);
  };

  const paginationMeta = useMemo(() => {
    const totalDocs = competitionStats?.length || 0;
    const totalPages = Math.ceil(totalDocs / sizePerPage) || 0;
    return {
      totalDocs,
      totalPages,
      page,
      hasNextPage: page < totalPages,
      hasPrevPage: page > 1,
      nextPage: page < totalPages ? page + 1 : totalPages,
      prevPage: page > 1 ? page - 1 : 1,
    };
  }, [competitionStats, page, sizePerPage]);

  const paginatedStats = useMemo(() => {
    const start = (page - 1) * sizePerPage;
    const end = start + sizePerPage;
    return competitionStats?.slice(start, end) || [];
  }, [competitionStats, page, sizePerPage]);

  const toggleShowModal = () => {
    setShowModal(!show);
  };
  const columns = [
    {
      dataField: "name",
      text: props.t("Name"),
      formatter: (val) => `${val.firstName} ${val.lastName}`
    },
    {
      dataField: "email",
      text: props.t("Email"),

    },
    {
      dataField: "tradingAccounts",
      text: props.t("Accounts"),
      formatter: (val) => `${val?.logins?.toString() || "---"}`

    },
    {
      dataField: "totalAmount",
      text: props.t("Total Amount"),
      formatter: (val) => (
        <>
          <div>{`${val?.totalAmount?.toFixed(2)}`}</div>
        </>
      ),
    },
    {
      dataField: "",
      text: props.t("Select Winner"),
      formatter: (val) => {
        return <>
          <WinnerButton
            competitionDetails={{ ...props }}
            customer={{ ...val }}
            onClick={(event, values) => {
              toggleShowModal(values);
              setRewardModalValues(values);
            }}
            t={props.t}
          ></WinnerButton>
        </>;
      }
    }
  ];
  return (<>
    <Row>
      <Col className="col-12">
        <Card>
          <CardHeader className="d-flex flex-column gap-3">
            <div className="d-flex justify-content-between  align-items-center">
              <CardTitle className="color-primary">{props.t("Competition Stats")} ({props.t(props.name)})</CardTitle>
            </div>
            <h6 className="text-center">{props.t("Competition Stats only changes every 15 minutes")}</h6>
          </CardHeader>
          <CardBody>
            <div className="table-rep-plugin">
              <div
                className="table-responsive mb-0"
                data-pattern="priority-columns"
              >
                <Table
                  id="tech-companies-1"
                  className="table table-hover table-clients"
                >
                  <Thead className="text-center table-light">
                    <Tr>
                      {columns.map((column, index) =>
                        <Th data-priority={index} key={index}>
                          <span className="color-primary">{column.text}</span>
                        </Th>
                      )}
                    </Tr>
                  </Thead>
                  <Tbody className="text-center" style={{ fontSize: "13px" }}>
                    {props.loading && <TableLoader colSpan={columns.length} />}
                    {!props.loading && paginatedStats?.map((row, rowIndex) =>
                      <Tr key={rowIndex}>
                        {columns.map((column, index) =>
                          <Td key={`${rowIndex}-${index}`}
                            style={{
                              overflow: column.dataField === "actions" && "visible",
                              maxWidth: column.dataField === "actions" && "140px"
                            }}>
                            {column.formatter ? column.formatter(row, rowIndex) : row[column.dataField]}
                          </Td>
                        )}
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
      <CustomPagination
        totalPages={paginationMeta.totalPages}
        docs={paginatedStats}
        sizePerPage={sizePerPage}
        page={paginationMeta.page}
        totalDocs={paginationMeta.totalDocs}
        hasNextPage={paginationMeta.hasNextPage}
        hasPrevPage={paginationMeta.hasPrevPage}
        prevPage={paginationMeta.prevPage}
        nextPage={paginationMeta.nextPage}
        setSizePerPage={handleSizeChange}
        onChange={handlePageChange}
      />
      <CompetitionRewardModal
        toggleShowModal={toggleShowModal}
        show={show}
        values={rewardModalValues}
        setCompetitionStats={setCompetitionStats}
        competitionStats={competitionStats}
      ></CompetitionRewardModal>
    </Row>
  </>);
}

export default CompetitionStats;
